export const CableTypeEnum = [
  { key: "Cat3", value: 0 },
  { key: "Cat5", value: 1 },
  { key: "Cat5E", value: 2 },
  { key: "Cat6", value: 3 },
  { key: "Cat6A", value: 4 },
  { key: "Cat7 and 7A", value: 5 },
  { key: "Cat8", value: 6 },
  { key: "USOC8 1Pair", value: 7 },
  { key: "USOC8 2Pair", value: 8 },
  // { key: "USOC8 3Pair", value: 9 },
  // { key: "USOC8 4Pair", value: 10 },
  { key: "ETH 1236", value: 11 },
  { key: "ETH 1278", value: 12 },
  { key: "Profinet 4W", value: 13 },
  { key: "COAX RGxx", value: 14 },
  { key: "ISDN BRI", value: 15 },
  { key: "DB", value: 16 },
  { key: "Custom", value: 17 }
];

export const NT3CableTypeEnum = [
  { key: "4-Pair", value: 18 },
  { key: "2-Pair (12-36)", value: 19 },
  { key: "2-Pair (12-78)", value: 20 },
  { key: "2-Pair (45-36)", value: 21 },
  { key: "1-Pair (45)", value: 22 }
]

export const ShieldTypeEnum = [
  { key: "UTP", value: 0 },
  { key: "STP", value: 1 },
  { key: "UTP/STP", value: 2 }
];

export const DispPrefEnum = [
  { key: "Standard", value: 0 },
  { key: "568A", value: 1 },
  { key: "568B", value: 2 },
  { key: "USOC", value: 3 },
  { key: "TERA", value: 4 }
];
